import { render } from "./NoticeModel.vue?vue&type=template&id=adf7df94&scoped=true"
import script from "./NoticeModel.vue?vue&type=script&lang=js"
export * from "./NoticeModel.vue?vue&type=script&lang=js"

import "./NoticeModel.vue?vue&type=style&index=0&id=adf7df94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adf7df94"]])

export default __exports__